import { render, staticRenderFns } from "./SubmitDataset.vue?vue&type=template&id=47546394&scoped=true&"
import script from "./SubmitDataset.vue?vue&type=script&lang=js&"
export * from "./SubmitDataset.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDataset.vue?vue&type=style&index=0&id=47546394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47546394",
  null
  
)

export default component.exports